export enum EMassRetagFormFields {
  FILE = 'file',
}

export interface MassRetagFormData {
  [EMassRetagFormFields.FILE]: File;
}

export interface MassRetagResponse {
  link: string;
}
